import * as S from "./styled"
import { TTicketDisposal } from "../../utils/@types/data/ticket"
import { formatMoney } from "../../utils/tb/formatMoney"
import MesaSelect from "../MesaSelect"
import { ReactComponent as DropdownIcon } from "../../assets/icons/arrow_down.svg"
import locationIcon from "../../assets/icons/location.svg"

type Props = {
  sectorName: string
  mesaType: "mesa" | "camarote"
  products: TTicketDisposal[]
  selectedId: string | null
  mapImage: string | null
  expanded: boolean
  onToggle: () => void
  onSelect: (productId: string | null) => void
  onViewMap: (imageUrl: string) => void
}

const MesaSectorGroup = ({
  sectorName,
  mesaType,
  products,
  selectedId,
  mapImage,
  expanded,
  onToggle,
  onSelect,
  onViewMap,
}: Props) => {
  const getLowerPrice = () => {
    let lower = 0

    products.forEach((p) => {
      if (lower !== 0) {
        if (p.price_sell < lower) lower = p.price_sell
      } else lower = p.price_sell
    })

    return formatMoney(lower, true)
  }

  const handleHeaderKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    // Ignore keydowns that bubbled up from a nested control (e.g. the
    // ViewMapLink button) — only react when the header itself is focused,
    // so the nested button's own Enter/Space activation doesn't also
    // trigger this disclosure toggle.
    if (e.target !== e.currentTarget) return

    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault()
      onToggle()
    }
  }

  return (
    <S.Component>
      <S.GroupInfo
        onClick={onToggle}
        onKeyDown={handleHeaderKeyDown}
        role="button"
        tabIndex={0}
        aria-expanded={expanded}
      >
        <S.GroupInfoMain>
          <S.GroupName>{sectorName || "Setor"}</S.GroupName>
          {mapImage && (
            <S.ViewMapLink
              onClick={(e) => {
                e.stopPropagation()
                onViewMap(mapImage)
              }}
            >
              <img src={locationIcon} alt="" />
              Ver mapa
            </S.ViewMapLink>
          )}
        </S.GroupInfoMain>
        <S.GroupInfoSecondary>
          <S.GroupBasePrice>
            A partir de <strong>{getLowerPrice()}</strong>
          </S.GroupBasePrice>
          <DropdownIcon
            style={{
              width: 20,
              height: 20,
              transition: "transform 0.3s",
              transform: `rotate(${expanded ? 180 : 0}deg)`,
            }}
          />
        </S.GroupInfoSecondary>
      </S.GroupInfo>
      {expanded && (
        <MesaSelect
          products={products}
          mesaType={mesaType}
          selectedId={selectedId}
          onSelect={onSelect}
        />
      )}
    </S.Component>
  )
}

export default MesaSectorGroup
